// removed by extract-text-webpack-plugin
module.exports = {"detail":"mZTuB _38618 _3Dqep _18-EI","detailBody":"_1GT7O _2kZNz","detailTitle":"cDEmX _3TD8R CO6xt","detailSubtitle":"_3XQ7b _17S31 _17V2F Tgxr2","detailSubtitleLight":"_18EFR _17V2F Tgxr2","detailTextarea":"_2ttuh _17S31 _2hwsw _2z9kb"};


//////////////////
// WEBPACK FOOTER
// ./reference/components/Detail.css
// module id = 1956
// module chunks = 3